// extracted by mini-css-extract-plugin
module.exports = {"item":"_1a2c4cff","active":"_5b9941e6","smallItemListContainer":"_fa635f65","itemPageContainer":"_62025b2b"};